<template>
    <section class="titLeft">
        <div class="container">
            <div class="hd clearfix">
                <h3 class="clearfix"><a>热门职位</a>
                    <el-button class="positionButton" type="primary" plain @click="handlePosition">更多职位>>
                    </el-button>
                </h3>
            </div>
            <ul class="clearfix position">
                <li v-for="item in dataList" :key="item.id">
                    <div @click="handleDetail(item)">
                        <p class="spaceBetween">
                            <span class="left"><span
                                    v-text="item.positionName">初稿数据</span>{{rangeFormatter(item)}}</span>
                            <span class="right" v-text="item.enterpriseName">小米科技有限责任公司</span>
                        </p>
                        <p class="spaceBetween"><span>职位关键词</span><span
                                v-text="industryFormatter(item.industry)"></span></p>
                        <p class="tag">
                            <i v-for="(item1, index) in keywordFormatter(item.keywordList)" :key="index" v-text="item1">交通出行</i>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
    import {findHotEnterprisePositionTop} from '@/api/job'

    const YEAR_WAGES = 0;       // 年薪
    const MONTHLY_WAGES = 1;    // 月薪
    const DAILY_WAGES = 2;      // 日薪
    const HOURLY_WAGES = 3;     // 时薪
    const FACE_TO_FACE_WAGES = 4;     // 面议
    export default {
        name: 'Position',
        data() {
            return {
                dataList: []
            }
        },
        created() {
            this.getPositionList();
        },
        methods: {
            getPositionList() {
                findHotEnterprisePositionTop().then((res) => {
                    this.dataList = res.data;
                });
            },
            handlePosition() {
                if (process.env.NODE_ENV == "development") {
                    window.open(window.location.origin + "/frontend#/jobList?active=position");
                } else {
                    window.open(window.location.origin + "/#/jobList?active=position");
                }
            },
            /** 薪资范围格式化*/
            rangeFormatter(row) {
                let msg = '';
                let min = row.minimumWage;
                let max = row.maximumWage;
                switch (row.payMethod) {
                    case YEAR_WAGES:
                        msg = min / 10000 + '-' + max / 10000 + 'W•年';
                        break;
                    case MONTHLY_WAGES:
                        msg = min / 1000 + '-' + max / 1000 + 'K•月';
                        break;
                    case DAILY_WAGES:
                        msg = min + '-' + max + '•日';
                        break;
                    case HOURLY_WAGES:
                        msg = min + '-' + max + '•时';
                        break;
                    case FACE_TO_FACE_WAGES:
                        msg = "面议";
                        break;
                }
                return msg;
            },
            industryFormatter(industry) {
                return industry ? JSON.parse(industry).join("/") : '';
            },
            keywordFormatter(keywordList) {
                return keywordList ? JSON.parse(keywordList) : [];
            },
            /** 打开职位详情*/
            handleDetail(job) {
                if (process.env.NODE_ENV == "development") {
                    window.open(window.location.origin + "/frontend#/jobDetails/" + job.id);
                } else {
                    window.open(window.location.origin + "/#/jobDetails/" + job.id);
                }
            }
        }
    };
</script>
